export default "/_next/static/images/sofa-big-b29d0ac4c4b27aae3f1e24c84211337d.png";